import React from "react";
import { Card } from "react-bootstrap";

interface WidgetProps {
    title: string;
    subTitle?: string | null;
    cultivar?: string | null;
    status?: string | null;
    showHeader?: boolean;
    children: React.ReactNode;
    renderActions: () => React.ReactNode;
}



const Widget = ({title, subTitle=null, cultivar=null, status=null, showHeader=true, renderActions, children}: WidgetProps) => {
    
    return (
        <Card className="mb-2">
            {showHeader &&
                <Card.Header className="p-1 pl-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <div style={{width:'100%'}}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div>{title}</div><div style={{ width: '100px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{cultivar}</div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center text-muted text-capitalize">
                                {subTitle ? <div style={{fontSize:"0.75rem"}}>{subTitle}</div> : ""}{<div style={{width:'100px', fontSize:"0.75rem", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{status}</div>}
                            </div>
                            {renderActions()}
                        </div>
                    </div>
                </Card.Header>
            }
            <Card.Body className="p-2">
                {children}
            </Card.Body>
        </Card>
    )
}

export default Widget;